import { CRM } from "@/components/crm/root/CRM";
import { authProvider } from "@/providers/firebase/authProvider";

const App = () => <CRM authProvider={authProvider} disableTelemetry />;

export default App;
